export default {"src":"/_next/static/media/insurance.49441620.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};